"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentUrl = void 0;
const getCurrentUrl = () => new URL(window.location.href);
exports.getCurrentUrl = getCurrentUrl;
//# sourceMappingURL=getCurrentUrl.js.map